//PAQUETERIAS
import { useEffect, useState, useMemo, useRef } from "react";

import { StickyTable } from "react-sticky-table";
import {CustomDialog, Confirm} from "react-st-modal";
import NotificationSystem from 'react-notification-system';

import TextField from "@mui/material/TextField";
//COMPONENTES
import AlertResponse from "../../main_components/alerts/alertResponse";
import MODAL_TABLE from "../../main_components/modal/modal_Table";

//ESTILOS
import "../../components_cfdi/estilo.css";
import '../../componentSociosNegocios/componentSectors/bonuses.css';
import "../../components_cfdi/modal.css";
import "./freez.css"; 
import FormControlLabel from "@mui/material/FormControlLabel";
//IMAGENES/ICONOS
import Delete from "../../imgComponents/borrar.png";
import CREATE from "../../imgComponents/create.png";
import Edit from "../../imgComponents/save.png";
import DETAILS from "../../imgComponents/lupa.png";
import PDF from "../../imgComponents/pdf.png";
import SOCIO from "../../imgComponents/socio.png";
import PUNTOVENTA from "../../imgComponents/puntoventa.png";
import DESCAPITALIZAR from "../../imgComponents/descapitalizar.png";
import WAREHOUSE from "../../imgComponents/warehouse.png";

import { refresh_token  } from "../../main_components/tokens/tokenrefresh";
import { pagination } from "../../main_components/pagination/pagination";
import EditFreez from "./utilities/EditFreez";
import CreateFreez from "./utilities/CreateFreez";
import { MovementsFrezzer } from "./utilities/MovementsFrezzer";
import {styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { HistoryFrezz } from "./utilities/HistoryFrezz";
import { DetailsFrezz } from "./utilities/DetailsFrezz";
import {delete_cabinets, get_cabinets_comodato } from "../../services/assets/assets";
import Checkbox from "@mui/material/Checkbox";
import TableContainer from "../../main_components/Table/TableContainer";
import { ConfirmDesc } from "./utilities/ConfirmDesc";
import { COLUMS_SHOW } from "../../main_components/Table/ColumsShow";
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";

const TableFreezer= () => {
  
  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    "& .MuiSwitch-switchBase": {
      margin: 1,
      padding: 0,
      transform: "translateX(6px)",
      "&.Mui-checked": {
        color: "#fff",
        transform: "translateX(22px)",
        "& .MuiSwitch-thumb:before": {
          backgroundImage: `url('data:image/svg+xml;base64,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')`,
        },
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
      width: 32,
      height: 32,
      "&:before": {
        content: "''",
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iMjAiIGhlaWdodD0iMjAiCnZpZXdCb3g9IjAgMCA1MCA1MCIKc3R5bGU9ImZpbGw6IzQwQzA1NzsiPgo8cGF0aCBkPSJNIDIyLjc4MTI1IDAgQyAyMS42MDU0NjkgLTAuMDAzOTA2MjUgMjAuNDA2MjUgMC4xNjQwNjMgMTkuMjE4NzUgMC41MzEyNSBDIDEyLjkwMjM0NCAyLjQ5MjE4OCA5LjI4OTA2MyA5LjI2OTUzMSAxMS4yNSAxNS41OTM3NSBMIDExLjI1IDE1LjY1NjI1IEMgMTEuNTA3ODEzIDE2LjM2NzE4OCAxMi4xOTkyMTkgMTguNjE3MTg4IDEyLjYyNSAyMCBMIDkgMjAgQyA3LjMwMDc4MSAyMCA2IDIxLjMwMDc4MSA2IDIzIEwgNiA0NyBDIDYgNDguNjk5MjE5IDcuMzAwNzgxIDUwIDkgNTAgTCA0MSA1MCBDIDQyLjY5OTIxOSA1MCA0NCA0OC42OTkyMTkgNDQgNDcgTCA0NCAyMyBDIDQ0IDIxLjMwMDc4MSA0Mi42OTkyMTkgMjAgNDEgMjAgTCAxNC43NSAyMCBDIDE0LjQ0MTQwNiAxOS4wMDc4MTMgMTMuNTExNzE5IDE2LjA3NDIxOSAxMy4xMjUgMTUgTCAxMy4xNTYyNSAxNSBDIDExLjUxOTUzMSA5LjcyMjY1NiAxNC41IDQuMTA5Mzc1IDE5Ljc4MTI1IDIuNDY4NzUgQyAyNS4wNTA3ODEgMC44MzIwMzEgMzAuNjk1MzEzIDMuNzk2ODc1IDMyLjM0Mzc1IDkuMDYyNSBDIDMyLjM0Mzc1IDkuMDY2NDA2IDMyLjM0Mzc1IDkuMDg5ODQ0IDMyLjM0Mzc1IDkuMDkzNzUgQyAzMi41NzAzMTMgOS44ODY3MTkgMzMuNjU2MjUgMTMuNDA2MjUgMzMuNjU2MjUgMTMuNDA2MjUgQyAzMy43NDYwOTQgMTMuNzY1NjI1IDM0LjAyNzM0NCAxNC4wNTA3ODEgMzQuMzg2NzE5IDE0LjEzNjcxOSBDIDM0Ljc1IDE0LjIyNjU2MyAzNS4xMjg5MDYgMTQuMTA5Mzc1IDM1LjM3NSAxMy44MzIwMzEgQyAzNS42MjEwOTQgMTMuNTUwNzgxIDM1LjY5NTMxMyAxMy4xNjAxNTYgMzUuNTYyNSAxMi44MTI1IEMgMzUuNTYyNSAxMi44MTI1IDM0LjQzMzU5NCA5LjE3MTg3NSAzNC4yNSA4LjUzMTI1IEwgMzQuMjUgOC41IEMgMzIuNzgxMjUgMy43NjE3MTkgMjguNjAxNTYzIDAuNTQyOTY5IDIzLjkzNzUgMC4wNjI1IEMgMjMuNTUwNzgxIDAuMDIzNDM3NSAyMy4xNzE4NzUgMCAyMi43ODEyNSAwIFogTSAyNSAzMCBDIDI2LjY5OTIxOSAzMCAyOCAzMS4zMDA3ODEgMjggMzMgQyAyOCAzMy44OTg0MzggMjcuNjAxNTYzIDM0LjY4NzUgMjcgMzUuMTg3NSBMIDI3IDM4IEMgMjcgMzkuMTAxNTYzIDI2LjEwMTU2MyA0MCAyNSA0MCBDIDIzLjg5ODQzOCA0MCAyMyAzOS4xMDE1NjMgMjMgMzggTCAyMyAzNS4xODc1IEMgMjIuMzk4NDM4IDM0LjY4NzUgMjIgMzMuODk4NDM4IDIyIDMzIEMgMjIgMzEuMzAwNzgxIDIzLjMwMDc4MSAzMCAyNSAzMCBaIj48L3BhdGg+Cjwvc3ZnPg==')`,
      },
    },
    "& .MuiSwitch-track": {
      backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
      borderRadius: 20 / 2,
    },
  }));


  //indices inicial y final

  const notificationSystemRef = useRef();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [data4, setData4] = useState([]);
  const [lote, setlote]=useState(false);

  const [open, setopen]=useState(false);
  const [modalT, setmodalT] = useState(false);
  const [menssage, setmenssage] = useState("");
  const [modalGeneral, setmodalGeneral] = useState(false);
  const [descapitalizado, setdescapitalizado]=useState(false);
  const [id_cabinets, setid_cabinets]=useState(null);
  var entrada = 0;
  const [filtersColumsView, setfiltersColumsView] = useState(true);


  const [viewcomodatado, setviewcomodatado]=useState(false);

  const [viewnumero_economico, setviewnumero_economico] = useState(
    localStorage.getItem("viewnumero_economico") === null
      ? true
      : localStorage.getItem("viewnumero_economico") === "true"
      ? true
      : false
  );
  const [viewactivo_fijo, setviewactivo_fijo] = useState(
    localStorage.getItem("viewactivo_fijo") === null
      ? true
      : localStorage.getItem("viewactivo_fijo") === "true"
      ? true
      : false
  );
  const [viewnumero_serie, setviewnumero_serie] = useState(
    localStorage.getItem("viewnumero_serie") === null
      ? true
      : localStorage.getItem("viewnumero_serie") === "true"
      ? true
      : false
  );
  const [viewmarca, setviewmarca] = useState(
    localStorage.getItem("viewmarca") === null
      ? true
      : localStorage.getItem("viewmarca") === "true"
      ? true
      : false
  );
  const [viewmvmodelo,  setviewmodelo] = useState(
    localStorage.getItem("viewmvmodelo") === null
      ? true
      : localStorage.getItem("viewmvmodelo") === "true"
      ? true
      : false
  );
  const [viewprod,  setviewprod] = useState(
    localStorage.getItem("viewprod") === null
      ? true
      : localStorage.getItem("viewprod") === "true"
      ? true
      : false
  );
  const [viewcapit,  setviewcapit] = useState(
    localStorage.getItem("viewcapit") === null
      ? true
      : localStorage.getItem("viewcapit") === "true"
      ? true
      : false
  );
  const [viewnota,  setviewnota] = useState(
    localStorage.getItem("viewnota") === null
      ? true
      : localStorage.getItem("viewnota") === "true"
      ? true
      : false
  );
  const [viewwarehouse,  setviewwarehouse] = useState(
    localStorage.getItem("viewnota") === null
      ? true
      : localStorage.getItem("viewnota") === "true"
      ? true
      : false
  );
  const [viewcode,  setviewcode] = useState(
    localStorage.getItem("viewcode") === null
      ? true
      : localStorage.getItem("viewcode") === "true"
      ? true
      : false
  );
  const [viewpos,  setviewpos] = useState(
    localStorage.getItem("viewpos") === null
      ? true
      : localStorage.getItem("viewpos") === "true"
      ? true
      : false
  );
  const [viewruta,  setviewruta] = useState(
    localStorage.getItem("viewruta") === null
      ? true
      : localStorage.getItem("viewruta") === "true"
      ? true
      : false
  );
  const [viewempleado,  setviewempleado] = useState(
    localStorage.getItem("viewempleado") === null
      ? true
      : localStorage.getItem("viewempleado") === "true"
      ? true
      : false
  );
  const [viewstatus,  setviewstatus] = useState(
    localStorage.getItem("viewstatus") === null
      ? true
      : localStorage.getItem("viewstatus") === "true"
      ? true
      : false
  );

useEffect(()=>{
  localStorage.setItem("viewnumero_economico", viewnumero_economico);
  localStorage.setItem("viewactivo_fijo", viewactivo_fijo);
  localStorage.setItem("viewnumero_serie", viewnumero_serie);
  localStorage.setItem("viewmarca", viewmarca);
  localStorage.setItem("viewmvmodelo", viewmvmodelo);
  localStorage.setItem("viewprod", viewprod);
  localStorage.setItem("viewcapit", viewcapit);
  localStorage.setItem("viewnota", viewnota);
  localStorage.setItem("viewwarehouse", viewwarehouse);
  localStorage.setItem("viewcode", viewcode);
  localStorage.setItem("viewpos", viewpos);
  localStorage.setItem("viewruta", viewruta);
  localStorage.setItem("viewempleado", viewempleado);
  localStorage.setItem("viewstatus", viewstatus);

},
[
  viewnumero_economico,
  viewactivo_fijo,
  viewnumero_serie,
  viewmarca,
  viewmvmodelo,
  viewprod,
  viewcapit,
  viewnota,
  viewwarehouse,
  viewcode,
  viewpos,
  viewruta,
  viewempleado,
  viewstatus
]
)


const [selectedRows, setSelectedRows] = useState([]);
const [allchecks, setallchecks]=useState(false);

useEffect(()=>{
  handleSubmit();
},[]);


//console.log(sessionStorage.getItem("roles_user"));

var permisosUsuario = sessionStorage.getItem("roles_user");
var permisoUsuarioReplace = permisosUsuario?.replace(/ /g, "");
var permisos = permisoUsuarioReplace?.split(",");
var permisoeditfrezz = permisos?.filter((x) => x === "ROLE_ASSETS_CONFIGURATION");
var permisoconfig = permisos?.filter((x)=>x === "ROLE_CONFIGURATION");



function alertas(msj,status){
  if(status===true){
    notificationSystemRef.current.addNotification({
      message:<AlertResponse msj={msj} view={true}></AlertResponse>,
      level: 'success',
      position: 'br', 
      autoDismiss: 10, 
    });  
  }else{
    notificationSystemRef.current.addNotification({
      message:<AlertResponse msj={msj} view={false}></AlertResponse>,
      level: 'error',
      position: 'br', 
      autoDismiss: 60, 
    });
  }  
}
const reconsultar=(n)=>{
  if(n===true){
    setmodalT(true);  
  }else{
    setmodalT(false);
  } 
}



const handleSubmit = async () => {

  if(entrada===0){
    setmodalGeneral(true);
    entrada=entrada+1;
  }
  setData([]);
  setopen(true);
  setmenssage("Buscando Congeladores");
  setmodalT(true);

  try {
    var rf_token = await refresh_token();
    if(rf_token===true){
      setTimeout(async() => {
        var prueba = await pagination(3, "cabinets");
        setData(prueba === null ? [] : prueba.filter(item=>item.id_cabinets_state_fk!=16));
        setData2(prueba === null ? [] : prueba.filter(item=>item.id_cabinets_state_fk==16));
        setopen(false);
        setmodalGeneral(false);
        setmodalT(false);
      }, 1000);
    }else{}
  } catch (error) {
    console.error(error);
    setopen(false);
    setmodalGeneral(false);
    setmodalT(false);
  }
};
const get_comodato = async (id) => {
  setmodalT(true);
  try{
    var rf_token = await refresh_token();
    if(rf_token===true){
      setTimeout(async() => {
        var d = await get_cabinets_comodato(id);
        const decodedData = atob(d=== null ? [] : d.data.base64);
        const byteArray = new Uint8Array(decodedData.length);
        for (let i = 0; i < decodedData.length; ++i) {
          byteArray[i] = decodedData.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        // crear un objeto URL y enlace de descarga
        const fileUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'comodato.pdf';
        // agregar el enlace al DOM y descargar el archivo
        document.body.appendChild(link);
        link.click();
        alertas("PDF Descargado con éxito", true);
        setmodalT(false);
      }, 1000);
    }else{}
  }catch(error){
    console.log("error", error);
    if(error?.response?.status===409){
      alertas("El congelador no está asignado a un punto de venta", false);
    }else{
      alertas("No se pudo descargar el PDF, vuelva a intentarlo más tarde", false);
    }
    setmodalT(false);
  }
};


const columns = useMemo(
  () => [
    {
      Header:()=>(
        <div>
          <img
            id="crearRol"
            src={CREATE}
            onClick={async () => {
              const result = await CustomDialog(               
             <div>
                 <CreateFreez handleSubmit={handleSubmit} alertas={alertas} reconsultar={reconsultar}></CreateFreez>
             </div>,
           {
             className: "modalpuntosventa",
             title:"Crear Nuevo Congelador",
             showCloseIcon: true,
             isCanClose:false,
           }
       );
     }}
            title="Crear Congelador"
            className="cursorPointer"
            alt=""
          ></img>
        </div>
      ),
     id: "Expand",
     Cell: ({row}) => {

      function guardardato(){  
        setid_cabinets(row.original.id);
       }

      return(
        <a {...row.getToggleRowExpandedProps()}>
          {row?.isExpanded ? <span title="Ocultar Detalles">🔼</span>: <span title="Mostrar Detalles" onClick={guardardato}>🔽</span>}
        </a>
        )
     }
    },
    {
      Header:"Acciones",
      Cell: ({row }) => {

      function descargarcomodato(){
        get_comodato(row.original.id);
      }

      const DeleteSector = async () => {  
        setmodalT(true);
        setData([]);
        setopen(true);

        try {  
          var rf_token = await refresh_token();
          if(rf_token===true){
            setTimeout(async() => {
              var d = await delete_cabinets(row.original.id);
              console.log(d);
              alertas("Congelador Eliminado con éxito", true);
              handleSubmit();
            }, 1000);
          }else{}
        } catch (error) {
          console.error(error);
          setopen(false);
          alertas("Error, no se pudo Eliminar el congelador", false);
          setmodalT(false);
          handleSubmit();
        }
      }
        return (
          <div>
            <img
              src={Delete}
              onClick={async() =>{
                  const result = await Confirm('¿Esta usted seguro de eliminar el Congelador?','Eliminar Congelador','Si','No');
                  if(result){
                    DeleteSector()
                    }
                  }            
                }
              className="iconos-frez"
              title="Eliminar Congelador"
              alt=""
            ></img>
            {
               permisoeditfrezz.length===1?
               <img
               src={Edit}
               onClick={
                 async () => {
                   const result = await CustomDialog(               
                  <div>
                     <EditFreez row={row} handleSubmit={handleSubmit} alertas={alertas} reconsultar={reconsultar}></EditFreez> 
                  </div>,
                {
                  className: "modalpuntosventa",
                  title:"Editar Congelador",
                  showCloseIcon: true,
                  isCanClose:false,
                }
            ); 
          }
         }
               className="iconos-frez"
               title="Editar Congelador"
               alt=""
             ></img>:null
            }
            {
              row.original.id_cabinets_state_fk===2?
              <img
                src={PDF}
                onClick={() => descargarcomodato()}
                className="iconos-frez"
                title="Descargar Comodato"
                alt=""
            ></img>:null
            }
            <img
              src={WAREHOUSE}
              onClick={() => {
                  CustomDialog(               
                 <div> 
                  <MovementsFrezzer row={row} movement={"almacen"} id={row.original.id} reconsultar={reconsultar} handleSubmit={handleSubmit} alertas={alertas}></MovementsFrezzer>
                 </div>,
               {
                 className: "modalTItle",
                 title:"Cambiar de Almacén",
                 showCloseIcon: true,
                 isCanClose:false,
               })
              }
            }
            className="iconos-frez"
            title="Cambiar de Almacén"
            alt=""
            ></img>

            {
              descapitalizado===false?
              <>
               <img
              src={SOCIO}
              onClick={() => {
                   CustomDialog(               
                 <div> 
                  <MovementsFrezzer row={row} movement={"cliente"} id={row.original.id} reconsultar={reconsultar} handleSubmit={handleSubmit} alertas={alertas}></MovementsFrezzer>
                 </div>,
               {
                 className: "modalTItle",
                 title:"Asignar a una persona",
                 showCloseIcon: true,
                 isCanClose:false,
               })
              }
            }
            className="iconos-frez"
            title="Asignar a una persona"
            alt=""
            ></img>
             <img
              src={PUNTOVENTA}
              onClick={() => {
                 CustomDialog(               
                 <div> 
                  <MovementsFrezzer row={row} movement={"puntoventa"} id={row.original.id} reconsultar={reconsultar} handleSubmit={handleSubmit} alertas={alertas}></MovementsFrezzer>
                 </div>,
               {
                 className: "modalTItle",
                 title:"Asignar a Punto de Venta",
                 showCloseIcon: true,
                 isCanClose:false,
               })
              }
            }
            className="iconos-frez"
            title="Asignar a Punto de Venta"
            alt=""
            ></img>
            <img
              src={DETAILS}
              onClick={() => {
                CustomDialog(               
                 <div> 
                  <DetailsFrezz row={row}></DetailsFrezz>
                 </div>,
               {
                 className: "modalTItle",
                 title:"Detalles del Congelador",
                 showCloseIcon: true,
                 isCanClose:false,
               })
              }
            }
            className="iconos-frez"
            title="Detalles del Congelador"
            alt=""
            ></img>
            {
              row.original.id_warehouse_fk===null?<></>:
              <img
              src={DESCAPITALIZAR}
              onClick={() =>
                CustomDialog(               
                  <div> 
                   <ConfirmDesc setSelectedRows={setSelectedRows} detalles={[row.original]} array={[row.original.id]} handleSubmit={handleSubmit} alertas={alertas} reconsultar={reconsultar}></ConfirmDesc>
                  </div>,
                {
                  className: "modalTItle",
                  title:"Confirmar Descapitalización",
                  showCloseIcon: true,
                  isCanClose:false,
                })
              }
              title="Descapitalizar Congelador"
              className="iconos-frez"
              alt=""
              ></img>  
            }
            
             
             </>:<></>
            }
          </div>
        );
      },
    },
    {
      Header:"Comodatado",
      accessor:(d)=>{
        return d.lending===true?"Si":"No"
      }
    },
    {
      Header: "Número Economico",
      accessor: "economic_number",
      show: viewnumero_economico,
      id: "economic_number"
    },
    {
      Header: "Activo Fijo",
      accessor:"fixed_asset",
      show: viewactivo_fijo,
      id: "fixed_asset"
    },
    {
      Header: "Número Serie",
      accessor:"serial_number",
      show: viewnumero_serie,
      id:"serial_number"
    },
    {
      Header: "Marca",
      accessor: "brand",
      show: viewmarca,
      id: "brand"
    },
    {
      Header: "Modelo",
      accessor: "model",
      show: viewmvmodelo,
      id:"model"
    }, 
    {
      Header: "Producción",
      accessor: "production_year",
      show: viewprod,
      id: "production_year"
    },
    {
      Header:"Capitalización",
      accessor: "capitalization_date",
      show: viewcapit,
      id: "capitalization_date"
    },
    {
      Header:"Nota",
      accessor: "note",
      show: viewnota,
      id: "note"
    },
    {
      Header: "Almacén",
      accessor: "warehouse",
      show: viewwarehouse,
      id: "warehouse"
    },
    {
      Header: "Código",
      accessor:"pos_code",
      show: viewcode,
      id: "pos_code"
    },
    {
      Header: "Punto Venta",
      accessor: "pos_name",
      show: viewpos,
      id:"pos_name"
    },
    {
      Header: "Ruta",
      accessor: "route",
      show: viewruta,
      id:"route"
    },
    {
      Header: "Empleado",
      accessor:"employee",
      show: viewempleado,
      id:"employee"
    },
    {
      Header: "Estado",
      accessor: "state",
      show: viewstatus,
      id:"state"
    },
    {
      Header:({row})=>{
        return (
          <div className="checktableconge">
            <Checkbox
              onChange={()=>handleRowSelectAll()}
              checked={allchecks}
            />
          </div>
        );
      },
      show: lote,
      id:"lote",
      Cell:({ row }) => {
      
        const isChecked = selectedRows.includes(row.original);
        return (
          <Checkbox
            checked={isChecked}
            onChange={()=>handleRowSelect(row.original)}
          />
        );
      },
    }
    ],
    [
      selectedRows,
      viewnumero_economico,
      viewactivo_fijo,
      viewnumero_serie,
      viewmarca,
      viewmvmodelo,
      viewprod,
      viewcapit,
      viewnota,
      viewwarehouse,
      viewcode,
      viewpos,
      viewruta,
      viewempleado,
      viewstatus,
      descapitalizado,
      viewcomodatado,
      lote
    ]
);

  const datacolum =[
    {
      view: viewnumero_economico,
      setview: setviewnumero_economico,
      label:"Número Economico"
    },
    {
      view: viewactivo_fijo,
      setview: setviewactivo_fijo,
      label:"Activo Fijo"
    },
    {
      view: viewnumero_serie,
      setview: setviewnumero_serie,
      label:"Número de Serie"
    },
    {
      view: viewmarca,
      setview: setviewmarca,
      label:"Marca"
    },
    {
      view: viewmvmodelo,
      setview: setviewmodelo,
      label:"Modelo"
    },
    {
      view: viewprod,
      setview: setviewprod,
      label:"Producción"
    },
    {
      view: viewcapit,
      setview: setviewcapit,
      label:"Capitalización"
    },
    {
      view: viewnota,
      setview: setviewnota,
      label:"Nota"
    },
    {
      view: viewwarehouse,
      setview: setviewwarehouse,
      label:"Almacén"
    },
    {
      view: viewcode,
      setview: setviewcode,
      label:"Código"
    },
    {
      view: viewpos,
      setview: setviewpos,
      label:"Punto Venta"
    },
    {
      view: viewempleado,
      setview: setviewempleado,
      label:"Empleado"
    },
    {
      view: viewruta,
      setview: setviewruta,
      label:"Ruta"
    },
    {
      view: viewstatus,
      setview: setviewstatus,
      label:"Estado"
    },
    {
      view: viewcomodatado,
      setview: handlecomodatos,
      label:"Congeladores en comodato"
    }
  ]



const handleRowSelect = (row) => {
  const isSelected = selectedRows.find((r) => r.id === row.id) !== undefined;
  if (isSelected) {
    setSelectedRows(selectedRows.filter((r) => r.id !== row.id));
  } else {
    setSelectedRows([...selectedRows, row]);
  }
};
const handleRowSelectAll = ()=>{
    if (selectedRows.length === data4.length) {
      setallchecks(false);
      setSelectedRows([]);
    } else {
      setallchecks(true);
      setSelectedRows(data4);
    }
};
//funcion para descapitalizar un lote de congeladores
function handledescap(){
  //console.log(selectedRows);
  const array = selectedRows.map(item=>item.id);

  if(array.length===0){
    alertas("No ha seleccionado Congeladores", false);
  }

  CustomDialog(               
    <div> 
     <ConfirmDesc setSelectedRows={setSelectedRows} detalles={selectedRows} array={array} handleSubmit={handleSubmit} alertas={alertas} reconsultar={reconsultar}></ConfirmDesc>
    </div>,
  {
    className: "modalTItle",
    title:"Confirmar Descapitalización",
    showCloseIcon: true,
    isCanClose:false,
  })
}


function viewdesc(){
  if(descapitalizado===false){
    setlote(false);
  }
  setdescapitalizado(!descapitalizado);
}
const handlechecked = (event) => {
  setfiltersColumsView(event.target.checked);
};

function handlelote(){
  if(lote===false){
    setData4(data.filter(item=>item.id_warehouse_fk==11 && item.id_cabinets_state_fk==5));
    setlote(true);
  }else{
    setlote(false);
  }
}


function handlecomodatos(){

  console.log("entra");

  if(viewcomodatado===false){

    console.log("entra");
    setviewcomodatado(true);
    if(descapitalizado===false){
      console.log(data.filter(item=>item.lending===true));
      setData3(data.filter(item=>item.lending===true));
    }else{
      console.log(data2.filter(item=>item.lending===true));
      setData3(data2.filter(item=>item.lending===true));
    }
  }else{
    setviewcomodatado(false);
  }
}


  return (
    <>
    <BREADCRUMBS niveles={
                [
                  {label: "CONSULTAR CONGELADORES", path: null},
                  {label: "MOVIMIENTOS DE ALMACENES DE CONGELADORES", path: "/consult_warehouse_movement_cabinets"}, 
                ]
              }
      ></BREADCRUMBS>
      
<div className="TableCongeladores">
  <div className="">         
  <NotificationSystem  ref={notificationSystemRef} ></NotificationSystem>
  <MODAL_TABLE
    open={true}
    message={menssage}
    modalGeneral={modalGeneral}
    modalT={modalT}
  ></MODAL_TABLE>
    
          <>
         
          <COLUMS_SHOW
            filtersColumsView={filtersColumsView}
            datacolums={datacolum}
          >
          </COLUMS_SHOW>
         
      <div className="containerCutBox">
                <div className="expen-8 color-1">
                  <FormControlLabel
                    control={
                      <MaterialUISwitch
                        sx={{ m: 1 }}
                        onChange={handlechecked}
                        checked={filtersColumsView}
                      />
                    }
                    label={
                      filtersColumsView === true
                        ? "Activar Filtros"
                        : "Desactivar Filtros"
                    }
                  />
                </div>
            </div>

          <div className="containerselectfrezz">
        
        <div className="selectfres">
            <TextField
                  select
                  label="Congeladores"
                  defaultValue={""}
                  InputLabelProps={{shrink: true}}
                  SelectProps={{native: true}}
                  sx={{ m: 1.5, width: "100%"}}
                  onChange={viewdesc}
                >
                  <option key={1} value={true}>
                      {"Congeladores Capitalizados"}
                  </option>
                  
                  <option key={2} value={false}>
                      {"Congeladores Descapitalizados"}
                  </option>
             </TextField>
        </div>
        <div className="selectfres2" style={permisoconfig.length===1?{"display":"block"}:{"display":"none"}}>
          
          {
            descapitalizado===false?
            lote===false?
              <button className="button" onClick={handlelote}>Descapitalización</button>:
              <button className="button-cancel" onClick={handlelote}>Cancelar</button>
            :<></>
          }
        </div>
        <div className="selectfres3">
          {
            descapitalizado===false?
            lote===false?<></>:
            <button className="button-confirm" onClick={handledescap}>Descapitalizar Lote</button>:
            <></>
          }
        </div>
      </div>
       
          <StickyTable>
            <TableContainer
              paginado={"Congeladores"}
              consultas={"Congeladores Consultados"}
              exportar={true}
              columns={columns}
              data={
                lote===true?data4:viewcomodatado===true?data3:descapitalizado===false?data:data2
              }
              style={{ overflowx: 10 }}
              renderRowSubComponent={row=>{
                return (
                  <div style={{ padding: "20px" }}>
                    <div className="subtablemodelo">
                    <HistoryFrezz
                      reconsultar={reconsultar}
                      alertas={alertas}
                      defaultPageSize={3}
                      showPagination={false}
                      id={id_cabinets}
                    />
                    </div>
                  </div>
                )
              }}
              Gmodal={open}

            />
          </StickyTable>
          </>   
          </div>
        </div>
    </>
  );
}

export default TableFreezer;
